const prefixCls = 'web.setting.';
export const localesSetting = {
  [prefixCls + 'color-light']: {
    zh_CN: '切换到亮色模式',
    en_GB: 'Switch to bright color mode',
  },
  [prefixCls + 'color-dark']: {
    zh_CN: '切换到暗色模式',
    en_GB: 'Switch to dark mode',
  },
};
